import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F4C3A814-205E-4F0A-9B3D-34B5777A4237
 * name video-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-off.svg
 * tags
 * - Video / Movie 
 * - Home Automation 
 */
export const VideoOffIcon = createSvgIcon(<><path d="M3.27,2L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7A1,1 0 0,0 16,6H9.82L21,17.18V6.5Z" /></>, 'VideoOffIcon');
export default VideoOffIcon